import React from 'react';
import { useApolloClient } from 'react-apollo';
export const withApolloClient = (WrappedComponent) => {
    const ComponentWithClient = (props) => {
        const client = useApolloClient();
        return (React.createElement(WrappedComponent, { ...{
                ...props,
                client,
            } }));
    };
    ComponentWithClient.displayName = `withApolloClient(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithClient;
};
//# sourceMappingURL=withApolloClient.js.map